import {gql, useMutation} from "@apollo/client";

const ADD_CREATE_SCHEDULE_MUTATION = gql`
mutation CreateSchedule($stageId: Int!) {
  createSchedule(stageId: $stageId) {
    success
  }
}
`;

export default function CreateScheduleMutation() {
    return useMutation(ADD_CREATE_SCHEDULE_MUTATION);
}